import { render, staticRenderFns } from "./Cabecalho.vue?vue&type=template&id=7322230c"
import script from "./Cabecalho.vue?vue&type=script&lang=js"
export * from "./Cabecalho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports